package org.example.project.enginekalender

import kotlinx.serialization.decodeFromString
import kotlinx.serialization.encodeToString
import kotlinx.serialization.json.Json
import kotlinx.serialization.json.jsonObject
import kotlinx.serialization.json.jsonPrimitive
import org.example.project.manager.LumaticaApiManager
import org.example.project.service.GlobalManager
import org.example.project.utils.All

private val aufgabenJson = Json { ignoreUnknownKeys = true; encodeDefaults = false }

private fun checkAufgabenResponse(raw: String) {
    val response = runCatching { aufgabenJson.parseToJsonElement(raw).jsonObject }.getOrNull()
        ?: error("Aufgaben konnten nicht gespeichert werden.")
    if (response["ok"]?.jsonPrimitive?.content != "true") {
        error(response["error"]?.jsonPrimitive?.content ?: "Aufgaben konnten nicht gespeichert werden.")
    }
    GlobalManager.markJsonChanged("aufgaben", "user/aufgaben")
}

suspend fun loadOwnKalenderAufgaben(): List<All> {
    val raw = LumaticaApiManager.call("kalender/aufgaben/list")
    return runCatching { aufgabenJson.decodeFromString<List<All>>(raw) }
        .getOrElse { error("Aufgaben konnten nicht geladen werden.") }
}

suspend fun saveOwnKalenderAufgabe(task: All) {
    checkAufgabenResponse(LumaticaApiManager.postJson(
        "kalender/aufgaben/save", aufgabenJson.encodeToString(All.AllNames.serializer(), task)
    ))
}

suspend fun deleteOwnKalenderAufgabe(task: All) {
    checkAufgabenResponse(LumaticaApiManager.postJson(
        "kalender/aufgaben/delete", aufgabenJson.encodeToString(All.AllNames.serializer(), task)
    ))
}

suspend fun copyOwnKalenderAufgaben(sources: List<String>, targets: List<String>) {
    val body = aufgabenJson.encodeToString(mapOf("sources" to sources, "targets" to targets))
    checkAufgabenResponse(LumaticaApiManager.postJson("kalender/aufgaben/copy", body))
}
